// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// 1. Accept 'allowedRoles' as a prop
function ProtectedRoute({ children, allowedRoles }) {
  // 2. We need 'userProfile' because that contains the Firestore data (role), 
  //    not just the 'currentUser' (which is just the Auth token).
  const { currentUser, userProfile } = useAuth();
  const location = useLocation();

  // Check 1: Is the user authenticated at all?
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check 2: If this route has restricted roles, does the user match?
  if (allowedRoles && allowedRoles.length > 0) {
    // We safeguard against userProfile being null (which can happen if Firestore fetch fails)
    const userRole = userProfile?.role; 

    if (!userRole || !allowedRoles.includes(userRole)) {
      // User is logged in, but lacks the specific role.
      // Redirect them to the Menu (Safe Zone) instead of Login.
      return <Navigate to="/menu" replace />;
    }
  }

  // If we pass both checks, render the page
  return children;
}

export default ProtectedRoute;